

import React from "react";
import styles from "./Header.module.css";
import { useUser } from "../../context/UserContext";

const Header = ({ onMenuClick, pageTitle }) => {
  const { user } = useUser();

  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return "Good morning";
    if (hour < 18) return "Good afternoon";
    return "Good evening";
  };

  const displayName =
    user?.first_name && user?.last_name
      ? `${user.first_name} ${user.last_name}`.trim()
      : user?.first_name || "Admin";

  const displayRole = user?.role
    ? user.role.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())
    : "Administrator";

  const initials =
    `${(user?.first_name || "").charAt(0)}${(user?.last_name || "").charAt(0)}`.toUpperCase() ||
    "AD";

  return (
    <header className={styles.header}>
      <div className={styles.left}>
        <button
          className={styles.menuBtn}
          onClick={onMenuClick}
          aria-label="Open navigation menu"
        >
          <span className={styles.menuIcon} />
          <span className={styles.menuIcon} />
          <span className={styles.menuIcon} />
        </button>
        <div className={styles.titleBlock}>
          {pageTitle ? (
            <h1 className={styles.pageTitle}>{pageTitle}</h1>
          ) : (
            <>
              <h1 className={styles.greeting}>
                {getGreeting()}, {displayName}!
              </h1>
              <p className={styles.subtext}>Welcome back to your dashboard.</p>
            </>
          )}
        </div>
      </div>

      <div className={styles.right}>
        <div className={styles.avatar}>{initials}</div>
        <div className={styles.userInfo}>
          <span className={styles.userName}>{displayName}</span>
          <span className={styles.userRole}>{displayRole}</span>
        </div>
      </div>
    </header>
  );
};

export default Header;
